import type { FilterFieldType } from '../types';

export const getFilterFieldType = (kind: string): FilterFieldType => {
	switch (kind) {
		case 'customer':
			return 'customer';
		case 'int':
		case 'float':
			return 'number';
		case 'date':
		case 'datetime':
			return 'date';
		case 'select':
			return 'select';
		default:
			return 'text';
	}
};
